import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

// Desloca o conteúdo a uma velocidade diferente da página ao fazer scroll.
export function Parallax({ children, speed = 40, className = "", tid }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [speed, -speed]);
  return (
    <motion.div ref={ref} style={{ y }} className={`will-change-transform ${className}`} data-testid={tid}>
      {children}
    </motion.div>
  );
}

// Aparece a subir quando entra no ecrã.
export function Reveal({ children, delay = 0, className = "", as = "div", ...rest }) {
  const M = motion[as];
  return (
    <M initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }} className={className} {...rest}>
      {children}
    </M>
  );
}
